module.exports = __webpack_public_path__ + "static/media/aave.bebcbda3.png";